// extracted by mini-css-extract-plugin
export default {"block":"ContentBlock_block__0iR1b","title":"ContentBlock_title__jQGqL","avatars":"ContentBlock_avatars__6XJpN","more":"ContentBlock_more__eXXIA"};